export enum NetworkStatusEnum {
	OFFLINE,
	ONLINE,
}
